import React from "react";
import { MultiSelect as MultiSelects } from "primereact/multiselect";
// import { PillsIcon } from "../icons/icons";
// import { FaSearch } from "react-icons/fa";
type BaseMultiSelectProp = {
  setValue?: (name: string, value: string) => void;
  name?: string;
  options: Array<{ id: string; name: string }>;
  label: string;
  selectedValues: Array<{ id: string; name: string }>;
  grid?: boolean;
  onRemoveItem: ( id: string ) => void;
  onChange: (e:any) => void;
  disabled?: boolean;
};

const MultiSelect: React.FC<BaseMultiSelectProp> = ({
  setValue,
  name,
  options,
  label,
  selectedValues,
  grid = false,
  onRemoveItem,
  onChange,
  disabled,
}) => {
  // const initialState = selectedValues ? selectedValues : [];

  // const [selectedValue, setSelectedValue] = useState(initialState);

  const panelFooterTemplate = () => {
    const selectedItems = selectedValues;
    const length = selectedItems ? selectedItems.length : 0;
    return (
      <div className="py-2 px-3">
        <b>{length}</b> item{length > 1 ? "s" : ""} selected.
      </div>
    );
  };

  return (
    <div className="relative">
      <span className="p-float-label">
        <MultiSelects
          value={selectedValues}
          options={options}
          onChange={onChange}
          optionLabel="name"
          filter
          className="w-full h-[56px] border rounded-lg  opacity-75 font-[500] bg-[#F9FAFC]"
          panelFooterTemplate={panelFooterTemplate}
          disabled={disabled}
        />
        <label htmlFor={"inputId"} className={`absolute pl-2 z-[1] text-[1.2rem] font-[500] text-[#767B86] dark:text-[#575A65] duration-300 transform -translate-y-[0.6rem] scale-75 origin-[0] left-2.5 peer-focus:text-[#575A65] peer-focus:dark:text-[#575A65] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[0.6rem] ${selectedValues?.length  === 0 ? "top-10 text-[15px]" : "top-5 text-[14px]"}`}>
          {/* <FaSearch className="text-xs font-extralight" /> */}
          {label}
        </label>
      </span>

   
    </div>
  );
};

export default MultiSelect;
